/**
 * Eenvoudige weergave-handler
 * - Op pageload: leest ?weergave=..., opent panel, verwijdert alle query params uit de URL
 * - Op click op links met ?weergave=... (op dezelfde pagina): opent panel zonder reload
 */

/**
 * Check of een panel met deze naam voorkomt in de DOM
 * Panel markup: x-data="panelAnimation('panelName', $el)"
 */
function panelExists(panelName) {
  if (!panelName) return false;

  const allElements = document.querySelectorAll('[x-data]');

  for (const element of allElements) {
    const xData = element.getAttribute('x-data');
    if (!xData || !xData.includes('panelAnimation')) continue;

    const match = xData.match(/panelAnimation\(['"]([^'"]+)['"]/);
    if (match && match[1] === panelName) {
      return true;
    }
  }

  return false;
}

/**
 * Probeert een panel te openen via Alpine.store('panels')
 */
function openPanel(panelName) {
  if (!panelName) return;

  // Wacht tot Alpine klaar is
  if (typeof Alpine === 'undefined' || !Alpine.store || !Alpine.store('panels')) {
    document.addEventListener('alpine:initialized', () => openPanel(panelName), { once: true });
    return;
  }

  if (!panelExists(panelName)) {
    console.log(`Panel "${panelName}" niet gevonden op deze pagina.`);
    return;
  }

  Alpine.store('panels').open(panelName);
}

/**
 * Haalt weergave-parameter uit de huidige URL en verwijdert daarna ALLE query params
 */
function handleInitialWeergave() {
  let panelName = null;

  // Eerst checken of er een panelName in sessionStorage staat (van een link-click)
  const storedPanelName = sessionStorage.getItem('pendingWeergave');
  if (storedPanelName) {
    panelName = storedPanelName;
    sessionStorage.removeItem('pendingWeergave');
  } else if (window.location.search) {
    // Anders checken in de URL
    const params = new URLSearchParams(window.location.search);
    panelName = params.get('weergave');
  }

  // URL opschonen: alle query params weg, hash behouden
  if (window.location.search) {
    const newUrl = window.location.pathname + (window.location.hash || '');
    window.history.replaceState(null, '', newUrl);
  }

  if (panelName) {
    // Wacht even tot Alpine en alle content geladen is
    setTimeout(() => {
      openPanel(panelName);
    }, 100);
  }
}

// Init: na DOM geladen weergave uit URL afhandelen
document.addEventListener('DOMContentLoaded', handleInitialWeergave);

// Link-clicks met ?weergave=... onderscheppen (alle pagina's)
document.addEventListener('click', (e) => {
  const link = e.target.closest('a[href*="weergave="]');
  if (!link) return;

  const href = link.getAttribute('href');
  if (!href) return;

  try {
    const url = new URL(href, window.location.origin);
    const panelName = url.searchParams.get('weergave');
    if (!panelName) return;

    const isSamePage = url.pathname === window.location.pathname;

    if (isSamePage) {
      // Zelfde pagina, voorkom navigatie en open direct het panel
      e.preventDefault();
      openPanel(panelName);
    } else {
      // Andere pagina: sla panelName op en navigeer naar schone URL
      e.preventDefault();
      sessionStorage.setItem('pendingWeergave', panelName);
      const cleanUrl = url.pathname + (url.hash || '');
      window.location.href = cleanUrl;
    }
  } catch (err) {
    console.warn('Ongeldige URL in weergave-link:', href);
  }
});
